import React from "react";
import { DocumentMatchStatus } from "@common/types/matchStatus";

interface MatchStatusFilterLabelProps {
    filters: {
        matchStatuses?: DocumentMatchStatus[];
    };
}

const STATUS_LABELS: Record<DocumentMatchStatus, string> = {
    [DocumentMatchStatus.MATCHED]: "Matched",
    [DocumentMatchStatus.NOT_MATCHED]: "Not matched",
};

export const MatchStatusFilterLabel: React.FC<MatchStatusFilterLabelProps> = ({
    filters: { matchStatuses },
}) => {
    if (!matchStatuses || matchStatuses.length === 0) {
        return null;
    }

    if (matchStatuses.length > 1) {
        return <>Match</>;
    }

    return <>{STATUS_LABELS[matchStatuses[0]]}</>;
};
